import controller from './categories-slider-filter.controller';
import templateBase from './templates/categories-slider-filter-base.view.html';
import templateT1 from './templates/categories-slider-filter-t1.view.html';
import templateT2 from './templates/categories-slider-filter-t2.view.html';
import templateT4 from './templates/categories-slider-filter-t4.view.html';
import templateT10 from './templates/categories-slider-filter-t10.view.html';
import templateT11 from './templates/categories-slider-filter-t11.view.html';
import templateT13 from './templates/categories-slider-filter-t13.view.html';

let CategoriesSliderFilterComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        hijas:'@',
        isProcedure:'<',
        sisters:'<',
        company:'<',
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
  let response = SessionService.get('components');

  if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t1') {
    return templateT1;
  } else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t2') {
    return templateT2;
  } else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t4') {
    return templateT4;
  } else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t10') {
    return templateT10;
  } else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t11') {
    return templateT11;
  } else if (response.CATEGORIES_SLIDER_FILTER.component == 'template_t13') {
    return templateT13;
  } else {
    return templateBase;
  }
}

export default CategoriesSliderFilterComponent;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.component.js
 **/